export class BusinessInfo {
  public id: number;
  public name: string;
  public replacementStage: string;
  public ownerUserName: string;
  public replacementName: string;
  public expiry: Date;
  public subscriptionId: number;
}
